var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-group',{attrs:{"config":_vm.group},on:{"click":_vm.onClick,"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_c('v-rect',{ref:"rect",attrs:{"config":_vm.border}}),_c('app-text',{attrs:{"config":_vm.text,"fixed":true,"anchor":"leftcenter"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }